var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-row',[_c('rkm-col',{attrs:{"cols":"12"}},[_c('rkm-form-textarea',{attrs:{"name":"observacao","rows":"4","max-rows":"4","validations":_vm.validations.complemento},model:{value:(_vm.data.model.complemento),callback:function ($$v) {_vm.$set(_vm.data.model, "complemento", $$v)},expression:"data.model.complemento"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }